import { PRODUCT_DETAIL_SUCCESS, PRODUCT_DETAIL_REQUEST, PRODUCT_DETAIL_ERROR } from 'actions/productDetailsActions';

import { INIT, LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import get from 'lodash/get';

const defaultState = {
	asyncStatus: INIT
};

export default function productActions(state = defaultState, action) {
	switch (action.type) {
		case PRODUCT_DETAIL_REQUEST:
			return { ...state, asyncStatus: LOADING };

		case PRODUCT_DETAIL_SUCCESS:
			return {
				...get(action.data, ['data', 'product_share_1', 'data', 0, 'value']),
				asyncStatus: SUCCESS
			};

		case PRODUCT_DETAIL_ERROR:
			return { ...state, asyncStatus: ERROR };

		default:
			return state;
	}
}
